import * as formatting from './formatting';
import { fetchA } from '@bb/session-manager';

/**
 * This class is meant to be a helpful frontend interface for the Generic
 * Mongo Data Router found in v2 of the bbwebapi.
 */
export class MongoStatsAPI {
  // Root url to append to
  baseUrl = new URL('/api/v2/mongo/', window.location.origin).toString();
  // Name from the mongoose schema within bbwebapi API
  mongoSchemaName = '';
  // A URL friendly version of the schema name
  urlId = '';

  /**
   *
   * @param {string} mongodbSchemaName Name of Schema from mongoose.
   */
  constructor(mongodbSchemaName) {
    this.mongoSchemaName = mongodbSchemaName;
    this.urlId = formatting.toUrlCase(mongodbSchemaName);
    this.baseUrl = new URL(`${this.urlId}/stats`, this.baseUrl).toString();
  }

  /**
   * Stat fetching from the V2 API within bbwebapi
   *
   * @param {object} params Various params
   * @param {boolean} params.no_cache If true, will not use cache for this request.
   * @param {string[]} params.stats Fields to return.
   * @param {object} params.query Mongodb query to filter before getting stats.
   * @param {string} params.search Adds search text to the query
   * @returns object containing json response
   */
  async fetchStats(params = {}) {
    const qParams = formatting.serializeParams(params);
    const resp = await fetchA(`${this.baseUrl}?${qParams}`);
    return resp.json();
  }

  /**
   * Bulk stat fetching from the V2 API within bbwebapi
   *
   * @param {object} stats Array of stat param bodies.
   * @returns object containing json response
   */
  async fetchStatsBulk(stats = []) {
    const resp = await fetchA(`${this.baseUrl}/bulk`, {
      method: 'POST',
      body: JSON.stringify({ stats }),
    });
    const jsonResp = await resp.json();
    if (!resp.ok) {
      throw new Error(`Bad server response: ${jsonResp.message}`);
    }
    return jsonResp;
  }
}
